import { render, staticRenderFns } from "./pcard.vue?vue&type=template&id=18109111&"
import script from "./pcard.vue?vue&type=script&lang=js&"
export * from "./pcard.vue?vue&type=script&lang=js&"
import style0 from "./pcard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports